var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccParking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Parking",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8380",
    "data-name": "Rectangle 8380",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35226",
    "data-name": "Group 35226",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35873",
    "data-name": "Path 35873",
    d: "M15.353,9.858H12.566v3.5h2.787a2.373,2.373,0,0,0,1.592-.478,1.681,1.681,0,0,0,.479-1.266,1.681,1.681,0,0,0-.478-1.274,2.529,2.529,0,0,0-1.592-.478",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35874",
    "data-name": "Path 35874",
    d: "M23.557,2.293H4.447A2.142,2.142,0,0,0,2.3,4.425V23.557a2.142,2.142,0,0,0,2.132,2.15H23.557a2.142,2.142,0,0,0,2.15-2.132V4.443a2.142,2.142,0,0,0-2.132-2.15h-.018M20.212,13.92a4.6,4.6,0,0,1-1.672,1.592,5.216,5.216,0,0,1-2.549.558H12.647v4.858H9.222V7.071h6.769a5.216,5.216,0,0,1,2.549.558,4.6,4.6,0,0,1,1.672,1.592,4.443,4.443,0,0,1,.637,2.389,5.521,5.521,0,0,1-.637,2.309",
    fill: "#b3b5c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccParking);
export default __webpack_public_path__ + "static/media/mcc_parking.d4c812849fe01840a7469c3e5a249dc7.svg";
export { ForwardRef as ReactComponent };